import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  Card, CardBody, Col, Row,
} from 'reactstrap';
import ReactTableBase from 'src/shared/components/table/ReactTableBase';
import { useTranslation } from 'react-i18next';

const CancellationDetailsView = ({ reactTableData}) => {
  const [rows] = useState(reactTableData?.tableRowsData);
  const { t } = useTranslation('common');

  const tableConfig = {
    isEditable: false,
    isSortable: true,
    isResizable: true,
    withPagination: true,
    withSearchEngine: true,
    manualPageSize: [10, 50, 100, 1000],
    placeholder: 'Search by Order No., Dlv Tracking No....',
  };

  
  
  return (
    <Col md={12} lg={12}>
      <Card>
        <CardBody>
          <Row>
            <Col md={12}>
              <h3 className="page-title">Order Recall Details</h3>
            </Col>
          </Row>
       
          {rows &&
          <ReactTableBase
            name={t('instution_type.view.name_map')}
            key={'searchable'}
            columns={reactTableData.tableHeaderData}
            data={rows}
            tableConfig={tableConfig}
          />
}
        </CardBody>
      </Card>
    </Col>
  );
};

CancellationDetailsView.propTypes = {
  reactTableData: PropTypes.shape({
    tableHeaderData: PropTypes.arrayOf(PropTypes.shape({
      key: PropTypes.string,
      name: PropTypes.string,
    })),
    tableRowsData: PropTypes.arrayOf(PropTypes.shape()),
  }).isRequired,
};

export default CancellationDetailsView;
